import { useState } from "react";
import { Form, Input, Button, Typography, App } from "antd";
import { UserOutlined, LockOutlined, LoginOutlined } from "@ant-design/icons";
import "./Login.scss";
import Logo from "../../assets/logo-PopPay.png";
import { useNavigate } from "react-router-dom";
import { URL } from "../../constant/url";


const { Text } = Typography;

const Login = () => {
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoading(true);

    try {
      const res = await fetch(`${URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      });

      const data = await res.json();

      // console.log(data)

      if (res.ok) {
        message.success("Login successful!");
        localStorage.setItem("token", data.token);
        localStorage.setItem("cashier", data.userName)
        localStorage.setItem("loginTime", data.loginTime)
        navigate("/locations", { replace: true });
      } else {
        message.error(data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      message.error("Unable to connect to server.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="logo-section">
          <div className="logo-icon">
            <img src={Logo} alt="logo PopPay" />
          </div>
          <div className="frame-sologan">
            <Text type="secondary" className="sologan-title">
              Streamline Your Business
            </Text>
            <hr />
            <Text type="secondary" className="login-title">
              Sign In
            </Text>
          </div>
        </div>

        <Form
          name="login-form"
          layout="vertical"
          onFinish={handleLogin}
          autoComplete="off"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please input your email!" },
              { type: "email", message: "Please enter a valid email!" },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="admin@gmail.com"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "Please input your password!" }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="admin123"
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              size="large"
              loading={loading}
              icon={<LoginOutlined />}
              className="login-btn"
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>

        <div className="footer-text">
          <Text type="secondary" style={{ fontSize: "12px" }}>
            © 2025 PopPay System - All Rights Reserved
          </Text>
          <br />
          <Text type="secondary" style={{ fontSize: "12px" }}>
            Designed & Powered by Vu Chau.
          </Text>
        </div>
      </div>
    </div>
  );
};

export default Login;
